import {
  GET_ALL_START,
  GET_ALL_SUCCESS,
  GET_ALL_ERROR,
  GET_SINGLE_START,
  GET_SINGLE_SUCCESS,
  GET_SINGLE_ERROR,
  UPLOAD_IMAGE_START,
  UPLOAD_IMAGE_SUCCESS,
  UPLOAD_IMAGE_ERROR,
  ADD_START,
  ADD_SUCCESS,
  ADD_ERROR,
  DELETE_START,
  DELETE_SUCCESS,
  DELETE_ERROR,
  UPDATE_START,
  UPDATE_SUCCESS,
  UPDATE_ERROR,
  EXPORT_START,
  EXPORT_SUCCESS,
  EXPORT_ERROR,
  GET_HNL_PLANT_CODE_START,
  GET_HNL_PLANT_CODE_SUCCESS,
  GET_HNL_PLANT_CODE_ERROR,
  GET_HNL_PRODUCT_START,
  GET_HNL_PRODUCT_SUCCESS,
  GET_HNL_PRODUCT_ERROR,
} from './types';

const initialState = {
  products: null,
  product: null,
  images: [],
  updated: null,
  isLoading: false,
  isUploading: false,
  isLoadingExport: false,
  errorMessage: null,
  HnLplantCode: null,
  HnLProducts: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ALL_START:
      return { ...state, errorMessage: null, isLoading: true };

    case GET_ALL_SUCCESS:
      return {
        ...state,
        products: payload || null,
        errorMessage: null,
        isLoading: false,
      };

    case GET_ALL_ERROR:
      return {
        ...state,
        errorMessage: payload || null,
        isLoading: false,
      };

    case GET_SINGLE_START:
      return { ...state, errorMessage: null, isLoading: true };

    case GET_SINGLE_SUCCESS:
      return {
        ...state,
        product: payload || null,
        errorMessage: null,
        isLoading: false,
      };

    case GET_SINGLE_ERROR:
      return {
        ...state,
        errorMessage: payload || null,
        isLoading: false,
      };

    case UPLOAD_IMAGE_START:
      return { ...state, errorMessage: null, isUploading: true };

    case UPLOAD_IMAGE_SUCCESS:
      return {
        ...state,
        images: payload || null,
        errorMessage: null,
        isUploading: false,
      };

    case UPLOAD_IMAGE_ERROR:
      return {
        ...state,
        errorMessage: payload || null,
        isUploading: false,
      };

    case ADD_START:
      return { ...state, errorMessage: null, isLoading: true };

    case ADD_SUCCESS:
      return {
        ...state,
        product: payload || null,
        errorMessage: null,
        isLoading: false,
      };

    case ADD_ERROR:
      return {
        ...state,
        errorMessage: payload || null,
        isLoading: false,
      };

    case DELETE_START:
      return { ...state, errorMessage: null, isLoading: true };

    case DELETE_SUCCESS:
      return {
        ...state,
        product: payload || null,
        errorMessage: null,
        isLoading: false,
      };

    case DELETE_ERROR:
      return {
        ...state,
        errorMessage: payload || null,
        isLoading: false,
      };
    case UPDATE_START:
      return { ...state, errorMessage: null, isLoading: true };

    case UPDATE_SUCCESS:
      return {
        ...state,
        updated: payload || null,
        errorMessage: null,
        isLoading: false,
      };

    case UPDATE_ERROR:
      return {
        ...state,
        errorMessage: payload || null,
        isLoading: false,
      };
    case EXPORT_START:
      return {
        ...state,
        errorMessage: null,
        isLoadingExport: true,
      };
    case EXPORT_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isLoadingExport: false,
      };
    case EXPORT_ERROR:
      return {
        ...state,
        errorMessage: payload || null,
        isLoadingExport: false,
      };
    case GET_HNL_PLANT_CODE_START:
      return {
        ...state,
        errorMessage: payload || null,
        isLoading: true,
      };
    case GET_HNL_PLANT_CODE_SUCCESS:
      return {
        ...state,
        HnLplantCode: payload || null,
        isLoading: false,
        errorMessage: null,
      };
    case GET_HNL_PLANT_CODE_ERROR:
      return {
        ...state,
        isLoading: false,
        errorMessage: payload || null,
      };
    case GET_HNL_PRODUCT_START:
      return {
        ...state,
        errorMessage: payload || null,
        isLoading: true,
      };
    case GET_HNL_PRODUCT_SUCCESS:
      return {
        ...state,
        HnLProducts: payload || null,
        isLoading: false,
        errorMessage: null,
      };
    case GET_HNL_PRODUCT_ERROR:
      return {
        ...state,
        isLoading: false,
        errorMessage: payload || null,
      };

    default:
      return state;
  }
};
